import { apiSlice } from 'api/apiSlice'
import {
  MosaicRaffleSearchResponse,
  Raffle,
  RaffleEntryCheck,
  RaffleEntryRequest,
  RaffleEntryResponse,
  RaffleNotifyRequest,
} from 'shared/types/raffles'

const rafflesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getRaffles: build.query<Raffle[], void>({
      query: () => ({
        app: 'sneakers',
        method: 'GET',
        url: '/api/raffles',
      }),
      transformResponse: (response: MosaicRaffleSearchResponse) =>
        response.hits.map((hit) => hit.data),
    }),
    submitRaffleEntry: build.mutation<RaffleEntryResponse, RaffleEntryRequest>({
      query: (body) => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: '/web-api/v1/raffles/entries',
      }),
      invalidatesTags: ['RaffleEntries'],
    }),
    checkRaffleEntry: build.query<RaffleEntryCheck, { raffleSlug: string }>({
      query: ({ raffleSlug }) => ({
        app: 'sneakers',
        method: 'GET',
        url: '/web-api/v1/raffles/entries',
        params: { raffleSlug },
      }),
      providesTags: ['RaffleEntries'],
    }),
    submitRaffleNotify: build.mutation<{ message: string }, RaffleNotifyRequest>({
      query: (body) => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: '/web-api/v1/email_registration/register',
      }),
    }),
  }),
})

export const {
  useGetRafflesQuery,
  useSubmitRaffleEntryMutation,
  useCheckRaffleEntryQuery,
  useSubmitRaffleNotifyMutation,
} = rafflesApi
